"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseOption = exports.UserInput = exports.SkeletonOption = exports.SkeletonDiv = exports.SelectWrapper = exports.Select = exports.OptionsWrapper = exports.Option = exports.Label = exports.Icon = exports.FeedbackText = exports.Close = exports.Chevron = exports.CheckMark = exports.Button = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _palette = require("../../styles/palette");
var _scUtils = require("../../utils/sc-utils");
var _Button = require("../Button");
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SelectWrapper = exports.SelectWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__SelectWrapper",
  componentId: "sc-19e8bk8-0"
})(["opacity:", ";display:", ";flex-direction:", ";align-items:", ";position:relative;width:100%;", "{font-size:14px;line-height:20px;color:", ";margin:0 0 4px;", "}"], function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 0.5 : 1;
}, function (_ref2) {
  var display = _ref2.display;
  return display !== null && display !== void 0 ? display : 'flex';
}, function (p) {
  return p.underlined ? 'row' : 'column';
}, function (p) {
  return p.underlined ? 'center' : 'flex-start';
}, function () {
  return Label;
}, _palette.commonPalette.textSecondary, function (p) {
  return p.underlined && "\n      color: ".concat(_palette.commonPalette.txGrey, ";\n      margin: 0 10px 0 0;\n\n      :after {\n        content: ':';\n      }\n    ");
});
var Label = exports.Label = _styledComponents["default"].label.withConfig({
  displayName: "styles__Label",
  componentId: "sc-19e8bk8-1"
})([""]);
var Button = exports.Button = (0, _styledComponents["default"])(_Button.Button).withConfig({
  displayName: "styles__Button",
  componentId: "sc-19e8bk8-2"
})([""]);
var Icon = exports.Icon = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "styles__Icon",
  componentId: "sc-19e8bk8-3"
})([""]);
var Select = exports.Select = _styledComponents["default"].div.withConfig({
  displayName: "styles__Select",
  componentId: "sc-19e8bk8-4"
})(["width:", ";height:40px;border:1px solid ", ";border-radius:4px;padding:0 16px;display:flex;align-items:center;justify-content:space-between;transition:border-color 0.2s easy-in-out;cursor:pointer;background-color:#fff;overflow:hidden;", " ", " ", "{> svg{margin:0 0 0 10px;transform:rotate(0deg);transition:transform 0.2s linear;", "}}"], function (_ref3) {
  var width = _ref3.width;
  return width ? "".concat(width, "px") : '100%';
}, _palette.commonPalette.borderGrey, function (p) {
  return p.disabled && "\n    background-color: ".concat(_palette.commonPalette.lightGrey, ";\n    color: ").concat(_palette.commonPalette.txLightGrey, ";\n    cursor: default;\n  ");
}, function (p) {
  return p.showSearch && "\n    cursor: text;\n  ";
}, function () {
  return Button;
}, function (p) {
  return p.open && "\n        transform: rotate(180deg);\n        transition: transform 0.2s linear;\n      ";
});
var UserInput = exports.UserInput = _styledComponents["default"].input.withConfig({
  displayName: "styles__UserInput",
  componentId: "sc-19e8bk8-5"
})(["border:none;width:88%;background:none;&:not(:disabled){cursor:pointer;}&:focus{outline:none;}&::placeholder{color:", ";}"], _palette.commonPalette.txLightGrey);
var OptionsWrapper = exports.OptionsWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__OptionsWrapper",
  componentId: "sc-19e8bk8-6"
})(["max-height:200px;overflow:auto;scrollbar-width:none;overscroll-behavior:contain;"]);
var baseOption = exports.baseOption = (0, _styledComponents.css)(["height:40px;font-size:14px;padding:0 16px;text-align:left;position:relative;cursor:pointer;display:flex;align-items:center;transition:all 100ms linear;&:hover{background-color:", ";}"], _palette.commonPalette.lightGrey);
var Option = exports.Option = _styledComponents["default"].div.withConfig({
  displayName: "styles__Option",
  componentId: "sc-19e8bk8-7"
})(["", " ", " ", " color:", ";font-weight:", ";", " &:hover{background-color:", ";}.icon{margin:0 0 0 auto;", "}", " ", "{margin-right:8px;}"], _scUtils.noSelect, _scUtils.ellipsis, baseOption, function (p) {
  return p.selected && !p.popover ? _palette.commonPalette.sgGreen : _palette.commonPalette.txBlack;
}, function (p) {
  return p.selected || !p.popover ? 400 : 300;
}, function (p) {
  return p.disabled && "\n    color: ".concat(_palette.commonPalette.txLightGrey, ";\n    cursor: default;\n  ");
}, _palette.commonPalette.lightGrey, function (p) {
  return !p.popover && "color: ".concat(_palette.commonPalette.sgGreen, ";");
}, function (p) {
  return p.popover && "\n\n    &:after {\n      content:\"\";\n      position: absolute;\n      bottom: 0;\n      left: 16px;\n      right: 16px;\n      border-bottom: 1px solid #e0e0e0;\n    }\n\n    &:last-child:after {\n      border-bottom: none;\n    }\n  ";
}, function () {
  return Icon;
});
var SkeletonOption = exports.SkeletonOption = _styledComponents["default"].div.withConfig({
  displayName: "styles__SkeletonOption",
  componentId: "sc-19e8bk8-8"
})(["", ""], baseOption);
var Chevron = exports.Chevron = (0, _styledComponents["default"])(_Icon["default"]).attrs({
  name: 'chevron-down'
}).withConfig({
  displayName: "styles__Chevron",
  componentId: "sc-19e8bk8-9"
})(["pointer-events:none;position:absolute;right:1rem;top:50%;transform:", ";transition:transform 0.2s linear;"], function (_ref4) {
  var opened = _ref4.opened;
  return opened ? 'translateY(-50%) rotate(-180deg)' : 'translateY(-50%)';
});
var CheckMark = exports.CheckMark = (0, _styledComponents["default"])(_Icon["default"]).attrs({
  name: 'checkmark'
}).withConfig({
  displayName: "styles__CheckMark",
  componentId: "sc-19e8bk8-10"
})(["pointer-events:none;right:1rem;"]);
var Close = exports.Close = (0, _styledComponents["default"])(_Icon["default"]).attrs({
  name: 'close'
}).withConfig({
  displayName: "styles__Close",
  componentId: "sc-19e8bk8-11"
})(["pointer-events:none;position:absolute;right:1rem;top:50%;"]);
var SkeletonDiv = exports.SkeletonDiv = _styledComponents["default"].div.withConfig({
  displayName: "styles__SkeletonDiv",
  componentId: "sc-19e8bk8-12"
})(["height:21px;width:", ";background-color:", ";animation:skeleton-loading 500ms linear infinite alternate;@keyframes skeleton-loading{0%{background-color:", ";}100%{background-color:", ";}}"], function (p) {
  var _p$width;
  return (_p$width = p.width) !== null && _p$width !== void 0 ? _p$width : '100%';
}, _palette.commonPalette.darkestGray, _palette.commonPalette.darkestGray, _palette.commonPalette.lightGrey);
var FeedbackText = exports.FeedbackText = _styledComponents["default"].p.withConfig({
  displayName: "styles__FeedbackText",
  componentId: "sc-19e8bk8-13"
})(["margin-top:8px;font-size:12px;line-height:16px;color:", ";"], _palette.commonPalette.textSecondary);
//# sourceMappingURL=styles.js.map